import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import { useDispatch } from "react-redux";
import RingLoader from "react-spinners/RingLoader";
import BButton from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import DropdownList from "react-widgets/DropdownList";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Field, reduxForm } from "redux-form";
import { onResetPasswordSubmit, onValidateToken } from "./actions";

import { colors } from "@material-ui/core";
const colorsData = [
  { color: "Red", value: "ff0000" },
  { color: "Green", value: "00ff00" },
  { color: "Blue", value: "0000ff" },
];

const validate = (values) => {
  const errors = {};
  const requiredFields = ["newPass", "confirmPass"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    } else if (
      values.newPass &&
      (values.newPass.length < 8 || values.newPass.length > 20)
    ) {
      errors.newPass =
        "Password should contain minimum 8 and maximum 20 characters ";
    } else if (!/[^a-zA-Z0-9 ]/i.test(values.newPass)) {
      errors.newPass = "Password should be Alphanumeric";
    } else if (values.confirmPass && values.newPass != values.confirmPass) {
      errors.confirmPass = "Password didn't match";
    }
  });

  return errors;
};

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    type="password"
    margin="normal"
    fullWidth
    label={label}
    autoFocus
    error={touched && error}
    helperText={error}
    {...input}
    {...custom}
    InputLabelProps={{
      style: {
        color: "black",
        fontFamily: "GT-Walsheim-medium",
        fontSize: "18px",
      },
    }}
  />
);

function ResetPassword(props) {
  let dispatch = useDispatch();
  let [token, setToken] = useState();
  let [isTokenInValid, setIsTokenInValid] = useState(true);
  let [isShowloading, setIsShowLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalText, setmodalText] = useState("");

  const handleModalClose = () => {
    setShowModal(false);
    props.history.push("/");
  };

  useEffect(() => {
    const resetEmail = JSON.parse(localStorage.getItem("resetEmail"));
    if (!resetEmail) {
      props.history.push("/");
    }
  }, []);

  const handleModalShow = () => setShowModal(true);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    let token = params.get("token");
    setToken(token);
    validateToken(token);
  }, [window.location.search]);

  const validateToken = (token) => {
    const resetEmail = JSON.parse(localStorage.getItem("resetEmail"));
    if (!resetEmail) {
      props.history.push("/");
    } else {
      dispatch(
        onValidateToken({
          email: resetEmail[0],
          resetToken: token,
        })
      )
        .then(() => {
          setIsShowLoading(false);
          setIsTokenInValid(false);
        })
        .catch((err) => {
          console.log(err, "err in token");
          setIsShowLoading(false);

          setIsTokenInValid(true);
        });
    }
  };

  const onSubmitForm = (val) => {
    const resetEmail = JSON.parse(localStorage.getItem("resetEmail"));
    dispatch(
      onResetPasswordSubmit({
        email: resetEmail[0],
        password: val.newPass,
        confirmPassword: val.confirmPass,
        resetToken: token,
      })
    )
      .then((res) => {
        setmodalText("Your password is reset successfully");
        setShowModal(true);
      })
      .catch((err) => {
        setmodalText("Something went wrong please try again!!");
        setShowModal(true);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#d9dbdf",
      }}
    >
      <Card style={{ maxWidth: "38rem" }}>
        <CardContent>
          {isShowloading && (
            <div className="sweet-loading">
              <RingLoader size={100} color={"#123abc"} loading={true} />
            </div>
          )}
          {!isShowloading && !isTokenInValid && (
            <div>
              <div>
                <Typography
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "30px",
                    whiteSpace: "nowrap",
                    color: "black",
                    paddingBottom: "15px",
                    textAlign: "center",
                  }}
                >
                  Reset Password
                </Typography>
              </div>

              <form
                style={{
                  padding: "0px 8px",
                }}
                onSubmit={props.handleSubmit(onSubmitForm)}
              >
                <div className="row">
                  <div className="col-md-12">
                    <Field
                      name="newPass"
                      component={renderTextField}
                      label="New Password *"
                      style={{
                        paddingTop: "6%",
                        fontFamily: "GT-Walsheim-medium",
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      name="confirmPass"
                      component={renderTextField}
                      label="Confirm Password *"
                      style={{
                        paddingTop: "6%",
                        fontFamily: "GT-Walsheim-medium",
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={false}
                      className="standard_purple_button"
                      style={{
                        backgroundColor: "rgb(79, 45, 127)",
                        color: "white",
                        outline: "none",
                      }}
                    >
                      Reset Password
                    </Button>
                  </div>
                </div>
              </form>

              <div>
                <Typography
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "darkslategray",
                    paddingTop: "17px",
                  }}
                >
                  **Password should contain minimum 8 and maximum 20 characters
                </Typography>
                <Typography
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "darkslategray",
                  }}
                >
                  **Password should contain Upper and lower character with
                  number or special characters
                </Typography>
              </div>
            </div>
          )}
          {!isShowloading && isTokenInValid && (
            <div style={{ padding: "2rem" }}>
              <h3>Sorry this link is expired</h3>
              <Button
                color="success"
                onClick={() => {
                  props.history.push("/");
                }}
              >
                Go Back to login page
              </Button>
            </div>
          )}
        </CardContent>
      </Card>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header>
          <Modal.Title>Password Reset Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalText}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="standard_purple_button"
            onClick={handleModalClose}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default reduxForm({
  form: "ResetPassword",
  validate,
})(ResetPassword);
